// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { userSetupUserInformationStyles } from "@awc/Overrides/Widgets/UserSetup/UserSetupUserInformation";
import { color, xScreen } from "@awc/XDL/Utilities";
import { css } from "styled-components";

userSetupUserInformationStyles.title = {
    variant: "h5",
    css: css`
        padding-bottom: 10px;
        border-bottom: 1px solid ${color("common.border")};
    `,
};

userSetupUserInformationStyles.userNameTextField =
    userSetupUserInformationStyles.emailAddressTextField =
    userSetupUserInformationStyles.firstNameTextField =
    userSetupUserInformationStyles.lastNameTextField =
        {
            cssOverrides: {
                formInputWrapper: css`
                    width: 60%;
                    ${xScreen("lte", "sm")} {
                        width: 100%;
                    }
                `,
            },
            labelProps: {
                css: css`
                    width: 40%;
                    text-align: left;
                `,
            },
        };

userSetupUserInformationStyles.requiredText = {
    css: css`
        &:before {
            content: "*";
            color: ${color("danger")};
            margin-right: 5px;
        }
        margin-bottom: 16px;
    `,
};
